import { Location } from 'vue-router'
import {
  CollectorPublication as Data,
  Session,
} from '@/typings/api/CollectorPublication'

import { TableAction, TableActionsTypes, createView } from '@/helpers/enums/table-actions'
import { MARKS_ROUTES as ROUTES } from './utils'

const VEERS_GENERATE: TableAction = {
  action: TableActionsTypes.generate,
  icon: 'mdi-refresh',
  tooltip: 'Запустить генерацию вееров',
}

const VEERS_UPLOAD: TableAction<Data> = {
  action: TableActionsTypes.accept,
  icon: 'mdi-upload-outline',
  tooltip: 'Загрузка обработанных вееров',
}

const TASKS_ORDER_UPLOAD: TableAction<Data> = {
  action: TableActionsTypes.positions_upload,
  icon: 'mdi-format-list-numbered',
  tooltip: 'Загрузка порядка заданий',
  getFilter: (data: Data) => data.procedure_type === 'GRAMOTNOST',
}

const ANSWERS_CONVERT: TableAction = {
  action: TableActionsTypes.convert,
  icon: 'mdi-bullseye',
  tooltip: 'Перевод ответов в баллы',
}

const DOWNLOAD: TableAction = {
  action: TableActionsTypes.download,
  icon: 'mdi-download',
  tooltip: 'Скачать итоговую выгрузку',
}

const UPLOAD: TableAction = {
  action: TableActionsTypes.upload,
  icon: 'mdi-upload',
  tooltip: 'Загрузить номера заданий или ключи',
}

const UPDATE: TableAction = {
  action: TableActionsTypes.update,
  icon: 'mdi-paperclip',
  tooltip: 'Загрузить исходные результаты',
}

const getViewRoute = (data: Data): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.publication_id.toString() },
})

export const getSessionNames = (data: Data, sessions: Session[]) => {
  if (sessions?.length > 0 && data.session_digit_code) {
    return sessions
      .filter(({ digit_code }) => digit_code === data.session_digit_code)
      .map(({ name }) => name)
      .join(', ')
  }

  return ''
}

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  createView<Data>(getViewRoute),
])

export const TABLE_ACTIONS = Object.freeze([
  UPDATE,
  DOWNLOAD,
  UPLOAD,
  VEERS_GENERATE,
  VEERS_UPLOAD,
  TASKS_ORDER_UPLOAD,
  ANSWERS_CONVERT,
])

export const TABLE_HEADERS = Object.freeze([
  // {
  //   text: 'Процедура',
  //   value: 'name',
  //   sortable: false,
  //   // getRoute: getViewRoute,
  // },
  {
    text: 'Тип',
    value: 'procedure_type',
    sortable: false,
    field: (value: Data['procedure_type']) => (value === 'REMOTE'
      ? 'Электронный'
      : value === 'GRAMOTNOST'
        ? 'Грамотность'
        : 'Бумажный'),
  },
  {
    text: 'Участников',
    value: 'tests_count',
    sortable: false,
  },
  {
    text: 'Сессия',
    value: 'session_code',
    sortable: false,
    getSessionNames,
  },
  {
    text: 'Предмет',
    value: 'subject_code',
    sortable: false,
  },
  {
    text: 'Ключи загружены',
    value: 'questions_uploaded',
    sortable: false,
    width: 80,
  },
  {
    text: 'Порядок заданий',
    value: 'task_order_uploaded',
    sortable: false,
    width: 80,
    getFilter: (data: Data) => data.procedure_type === 'GRAMOTNOST',
  },
])
